// TimeSeriesDialog.js
import { useState, useEffect, useRef } from "react"
import { Typography, Button } from '@mui/material'
import TimeSeriesForm from './TimeSeriesForm'
import { TimeSeriesChartjs } from './TimeSeriesChartjs'
import {showFile} from './OpenTimeseriesFile'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @param {function} setNewName Sets the new name of this object if the user modifies the name.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {function} setFullModel Sets the full model in case of any updates.
 * @returns UI for interactive swmm modeling.
 */
export default function TimeSeriesDialog({ model, targetType, target, setNewName, fullModel, setFullModel }) {
  const [submodel, setSubmodel] = useState()
  const [newTargetName, setNewTargetName] = useState(target)  
  const [tableData, setTableData] = useState([])
  const inputRef = useRef(null)


  useEffect(()=>{
    if(submodel)
      saveEdits(tableData)
  }, [tableData])
  
  const handleClick = () =>{
    // Open file on click
    inputRef.current.click()
    inputRef.current.value=null
  } 
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    let TIMESERIES = {[target]:[]}
    if(model.TIMESERIES && model.TIMESERIES[target]){
      TIMESERIES = {
        [target]: [
          ...model.TIMESERIES[target]
        ]
      }
    }

    setSubmodel({
      TIMESERIES: TIMESERIES
    })
  }, [])

  const saveEdits = (data) => {
    // Replace any slash '/' characters with dash '-' characters.
    data.forEach(v=>{
      v.DateTime = v.DateTime.toString()
      v.DateTime = v.DateTime.replaceAll('/', '-')
    })
    let cleanSub = {...submodel, TIMESERIES: {...submodel.TIMESERIES, [target]: [...data] }}

    setFullModel(prev => ({
      ...prev,
      TIMESERIES:{
        ...prev.TIMESERIES, 
        [target]: [
          ...cleanSub.TIMESERIES[target]
        ]
      }
    }))
  }

  function handleChange(e) {
    setNewName(e.target.value)
    setNewTargetName(e.target.value)
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(model){
    return(
      <>
      {
        <div style={{ flex:1, height:'100%', backgroundColor:'black'}} >
          <Typography id="modal-modal-title" variant="p4" >

            <div style={{display:"flex", flexFlow: "column", padding: '10px'}}>
              <label>Time Series Name</label>
              <input style={{fontSize: '16px', background: 'rgb(50, 50, 50)', color: 'lightskyblue', border: 'none', textAlign: 'center'}} type="text" value={newTargetName} onChange={handleChange} />
            </div>
            {
            <div style={{display:"flex", minHeight: '80px', height: 'calc(100% - 550px)'}}>
              <TimeSeriesChartjs 
                out_data={(fullModel && fullModel.TIMESERIES)?fullModel.TIMESERIES:[]} 
                model={fullModel}
                targets={[target]} 
                titleText={`Time Series Data`} />
            </div>
            }
            {
            <div>
              <Button fullWidth style={{minWidth: '0'}} onClick={handleClick}>Open</Button>
              <input 
                style={{display: 'none'}}
                ref={inputRef}
                type="file"
                accept=".dat"
                onChange={async (e) => {showFile(e, setTableData)}}
              />
            </div>
            }
            <div style={{display:"flex", minHeight: '80px', height: '380px'}}>
              {
                targetType && 
                targetType in model && 
                target &&
                <TimeSeriesForm model={model} target={target} targetType={'TIMESERIES'} saveEdits={saveEdits} />
              }
            </div>
          
          </Typography>
        </div>
      }
      </>
    )
  } else {
    return null
  }
}